(()=>{'use strict';
const confirmation=document.querySelector('[data-service-confirmation]');
if(!confirmation)return;
// Only server-confirmed contact submissions render this element.
requestAnimationFrame(()=>{confirmation.focus({preventScroll:true});confirmation.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});
})();
